import React from 'react';
import ListNotificationWrapper from './ListNotification.styles';
import { Button } from 'antd';
import { pushnotification } from '../../services/pushnotification.service';
import moment from 'moment';
import {
  WarningOutlined,
  UserOutlined,
  ToolOutlined,
  AlertOutlined,
  DashboardOutlined,
  BellOutlined,
  DeleteOutlined,
  CheckOutlined,
  EnvironmentOutlined,
  CameraOutlined
} from '@ant-design/icons';

const ListNotification = (props) => {
  const { dataNotification, getDataNotification, currentUser } = props;

  // Get icon based on notification type
  const getNotificationIcon = (type) => {
    switch (type?.toLowerCase()) {
      case 'hazard':
        return <WarningOutlined />;
      case 'visitor':
        return <UserOutlined />;
      case 'contractor':
        return <ToolOutlined />;
      case 'sos':
        return <AlertOutlined />;
      case 'sensor':
        return <DashboardOutlined />;
      default:
        return <BellOutlined />;
    }
  };

  // Get status color
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return '#FF0000'; // Red
      case 'monitoring':
        return '#FF9800'; // Orange
      case 'pending':
        return '#FFC107'; // Amber
      case 'resolved':
        return '#4CAF50'; // Green
      default:
        return '#FF0000'; // Red (default to active)
    }
  };

  // Get status display name
  const getStatusDisplay = (status) => {
    if (!status) return 'Active';
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  const onMarkRead = (id, e) => {
    e.stopPropagation();
    pushnotification.markRead(id).then(res => {
      if (res.code === "0000") {
        getDataNotification();
      }
    });
  };

  const onDismiss = (id, e) => {
    e.stopPropagation();
    pushnotification.dismiss(id).then(res => {
      if (res.code === "0000") {
        getDataNotification();
      }
    });
  };

  const onMarkAllRead = () => {
    if (dataNotification.length > 0) {
      const propertyId = dataNotification[0].property_id;
      pushnotification.markAllRead(propertyId).then(res => {
        if (res.code === "0000") {
          getDataNotification();
        }
      });
    }
  };

  const hasLocation = (notification) => {
    return notification.latitude && notification.longitude;
  };

  const hasPhoto = (notification) => {
    return notification.photo_url;
  };

  const renderListNotification = () => {
    return (
      <div className="notification-data-wrap">
        {dataNotification.length > 0 && (
          <div className="notification-header">
            <span className="notification-title">Notifications</span>
            <Button
              type="link"
              size="small"
              onClick={onMarkAllRead}
            >
              Mark all read
            </Button>
          </div>
        )}

        {dataNotification.length > 0 ? (
          <div className="notification-list">
            {dataNotification.map((data, index) => (
              <div
                key={data.id || index}
                className={`notification-item ${!data.is_read ? 'unread' : ''}`}
              >
                {/* Left: Icon */}
                <div className={`notification-icon-wrapper ${!data.is_read ? 'unread' : ''}`}>
                  {getNotificationIcon(data.type)}
                </div>

                {/* Right: Content */}
                <div className="notification-content">
                  {/* Title row with unread indicator */}
                  <div className="notification-title-row">
                    <h4 className={`notification-item-title ${!data.is_read ? 'unread' : ''}`}>
                      {data.title || 'Notification'}
                    </h4>
                    {!data.is_read && <span className="unread-dot" />}
                  </div>

                  {/* Subtitle */}
                  {data.subtitle && (
                    <div className="notification-subtitle">{data.subtitle}</div>
                  )}

                  {/* Details */}
                  {data.details && (
                    <div className="notification-details">{data.details}</div>
                  )}

                  {/* Bottom row: Status badge, time, indicators, actions */}
                  <div className="notification-footer">
                    <div className="notification-meta">
                      <span
                        className="status-badge"
                        style={{ backgroundColor: getStatusColor(data.status) }}
                      >
                        {getStatusDisplay(data.status)}
                      </span>
                      <span className="time-ago">{moment.utc(data.created_at).local().fromNow()}</span>
                      {hasLocation(data) && (
                        <EnvironmentOutlined className="indicator-icon" title="Has location" />
                      )}
                      {hasPhoto(data) && (
                        <CameraOutlined className="indicator-icon" title="Has photo" />
                      )}
                    </div>
                    <div className="notification-actions">
                      {!data.is_read && (
                        <Button
                          type="text"
                          size="small"
                          icon={<CheckOutlined />}
                          onClick={(e) => onMarkRead(data.id, e)}
                          title="Mark as read"
                        />
                      )}
                      <Button
                        type="text"
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={(e) => onDismiss(data.id, e)}
                        title="Dismiss"
                        className="dismiss-btn"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="notification-empty">
            <BellOutlined style={{ fontSize: 48 }} />
            <h4>No Notifications</h4>
            <p>You'll see alerts and updates here</p>
          </div>
        )}
      </div>
    );
  };

  return (
    <ListNotificationWrapper>
      {renderListNotification()}
    </ListNotificationWrapper>
  );
};

export default ListNotification;
